import { Entity } from '@toggle/toggle';
import React from 'react';

import { ErrorBoundaryWrapper } from '~/components/error-boundary-wrapper/ErrorBoundaryWrapper';
import { BrandAndProductDrawer } from '~/modules/brand-and-product-drawer/BrandAndProductDrawer';

import { BrandsAndProductsTable } from './brands-and-products-table/BrandsAndProductsTable';
import * as S from './BrandsAndProductsTab.styles';

export interface BrandsAndProductsTabProps {
  entity: Entity;
}

export const BrandsAndProductsTab = ({ entity }: BrandsAndProductsTabProps) => {
  return (
    <S.Root data-testid="brands-and-products-tab">
      <ErrorBoundaryWrapper
        fallback={<S.StyledErrorMessageWrapper displayIcon />}
      >
        <BrandsAndProductsTable entity={entity} />
      </ErrorBoundaryWrapper>
      <BrandAndProductDrawer entity={entity} />
    </S.Root>
  );
};
